export default __webpack_public_path__ + "_/images/promo_action/instructions/image2-8bbdffd063e1977ca4ad6fd2969cfed995b400274b5be86e86ae0b48eebaf16d.png";